document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-modal-trigger').forEach(button => {
    button.addEventListener('click', function () {
      const modalId = button.dataset.modalTarget;
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      }
    });
  });

  document.querySelectorAll('.custom-modal-close').forEach(closeButton => {
    closeButton.addEventListener('click', function () {
      const modal = closeButton.closest('.custom-modal');
      if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      }
    });
  });

  window.addEventListener('click', function (event) {
    const modal = event.target.closest('.custom-modal');
    if (!modal && event.target.classList.contains('custom-modal')) {
      event.target.style.display = 'none';
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }
  }); 
});

window.addEventListener('addToCartFromWebComponent', async function (e) {
  const { id, shopifyExternalId, imagePathPreview } = e.detail;

  if (!shopifyExternalId) {
    return;
  }

  try {
    const cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) {
      return;
    }

    const cartData = await cartResponse.json();
    const existingProduct = cartData.items.find(item => 
      item.properties && item.properties.consumerUserProductId === id
    );

    let productProperties;
    let productQuantity = 1;

    if (existingProduct) {
      productProperties = existingProduct.properties;
      productQuantity = existingProduct.quantity;
      await removeFromCart(existingProduct.key);
    } else {
      productProperties = {
        consumerUserProductId: id,
        _data_group: `group-${id}-${Date.now()}`
      };
    }

    const updatedImagePathPreview = imagePathPreview || '[]';
    const variantId = shopifyExternalId.replace('gid://shopify/ProductVariant/', '');

    const productData = {
      id: variantId,
      quantity: productQuantity,
      properties: productProperties
    };

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(productData),
    });

    if (response.ok) {
      await response.json();

      let customizeImage = Cookies.get('customizeImage');
      if (customizeImage) {
        customizeImage = JSON.parse(customizeImage);
        customizeImage.push({
          variantId: variantId,
          consumerProductId: id,
          updatedImagePathPreview: updatedImagePathPreview
        });
      } else {
        customizeImage = [{
          variantId: variantId,
          consumerProductId: id,
          updatedImagePathPreview: updatedImagePathPreview
        }];
      }

      Cookies.set('customizeImage', JSON.stringify(customizeImage));

      document.querySelectorAll('.custom-modal-close').forEach(button => button.click());

      updateCartCounters();
      refreshCartDrawer();
      updateCartPage();
      openMiniCart();
    } else {
      const errorResponse = await response.json();
      const errorDiv = document.querySelector('.account-dashboard__savedP-tile-cart-error');
      if (errorDiv) {
        errorDiv.textContent = errorResponse.description || "Errore durante l'aggiunta al carrello.";
        errorDiv.style.display = "block";
      }
    }
  } catch (error) {
    console.error(`Errore di rete durante l'aggiunta al carrello: ${error}`);
  }
});
